import Base64Image from 'component/Base64Image'
import styled from 'styled-components'
import themeAssetloadingSquareLoadingSvg from '@theme/loading/square-loading.svg'

export const Image = styled(Base64Image).attrs({
  aspectRatio: 900 / 240,
  source: 'picture',
  placeholder: themeAssetloadingSquareLoadingSvg,
  allowUnload: false,
})`
  /* width: 100%; */
  margin: 0 var(--cms-grid-column-gap);
  border-radius: 0.25rem;
`
